<!--专业服务详情--->
<!--wj-->
<template>
    <div class="spDetail">
        <detail-title></detail-title>
        <img :src="list.trspLogo" :onerror="imgs" style="width:100%;padding-top:6rem;">
        <div class="offline-detail">
            <p class="offline-title"><strong v-html="list.trspTitle">{{list.trspTitle}}</strong></p>
            <p class="offline-location">咨询电话：{{list.trspTel}}</p>
        </div>
        <div class="bbs-line"></div>
        <p class="offline-jj">简介</p>
        <div class="offline-detail">
            <p class="offline-intro" v-html="list.trspText">{{list.trspText}}</p>
        </div>
        <span class="Offline-footer">
            <button type="button" class="Offline-btn"><a v-bind:href="list.phoneCall" style="padding: 3% 35%;"><img src="@/assets/image/offline_tel.svg"  class="Offline-tel">马上咨询</a></button>
        </span>
        <share-wechat></share-wechat>
    </div>
</template>
<script>
import Axios from "axios";
import { eventBus } from '@/assets/js/eventBus';
import ShareWechat from "@/components/ShareWechat";
import DetailTitle from '@/components/DetailTitle';
export default {
    data(){
        return {
            imgs:'this.src="' + require("@/assets/image/gg1.jpg") + '"',
            list:[],
        };
    },
    mounted(){
        const that = this;
        var id="";
        var locations = location.href;
        if (locations.indexOf("?") != -1) {    //判断是否有参数
            if(locations.indexOf("from") != -1){
                var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
                var strs = str.split("?");
                id = strs[2];
            }else{
                var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
                var strs = str.split("?");
                id = strs[1];   //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
            }
        }
        var search ='';
        Axios.get(that.$store.state.APIURLS+"Trsp/findByIdEs?"+id+"&search="+search).then(function(res) {
            if(res.data.code == 200){
                if(res.data.data.trspTel){
                    res.data.data.phoneCall = "tel:" +res.data.data.trspTel;//咨询电话
                }
                that.list = res.data.data;
                var shareList = {
                    title: res.data.data.trspTitle,
                    content: res.data.data.trspText,
                };
                eventBus.$emit("shareList", shareList);
            }
        });
    },
    components:{
        DetailTitle,
        ShareWechat
    },
};
</script>

